import { Grid, makeStyles, Theme, useTheme } from "@material-ui/core";
import { DateTime } from "luxon";
import React, { Fragment, FunctionComponent, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useIdleTimer } from "react-idle-timer";
import { Redirect, Route, Switch } from "react-router";
import { BeatLoader } from "react-spinners";
import { preloadDigitalTwin } from "../../assets/models/3d-models";
import { Background } from "../../components/container/background";
import { SnackbarSeverity, useSnackbar } from "../../components/snackbar/snackbar-context";
import { useUser } from "../../components/user/user-context";
import { LOCAL_STORAGE_KEY } from "../../models/local-storage-keys";
import { ROUTES } from "../../router/router";

const useStyles = makeStyles((theme: Theme) => ({
  loadingContainer: {
    flex: 1,
    height: "100%",
  },
}));

interface IPortalPageProps {}

export const PortalPage: FunctionComponent<IPortalPageProps> = (props) => {
  const { logout, user, fetchUser } = useUser();
  const { showSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();

  useIdleTimer({
    timeout: 1000 * 60 * 30,
    onAction: () => {
      localStorage.setItem(LOCAL_STORAGE_KEY.LAST_ACTION, DateTime.now().toString());
    },
    onIdle: () => {
      showSnackbar(t("portal.inactivity_logout"), SnackbarSeverity.INFO, false);
      logout();
    },
  });

  useEffect(() => {
    fetchUser();
    preloadDigitalTwin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!user) {
    return (
      <Background>
        <Grid container className={classes.loadingContainer} justify="center" alignItems="center">
          <BeatLoader size={40} color={theme.palette.primary.main} />
        </Grid>
      </Background>
    );
  }

  return (
    <Switch>
      {user.onboardedAt && (
        <>
          {Object.values(ROUTES.PORTAL.ROUTES).map((ROUTE) => (
            <Fragment key={ROUTE.PATH}>
              {ROUTES.PORTAL.PATH === ROUTES.PORTAL.ROUTES.ONBOARDING.PATH && <Fragment key={ROUTE.PATH} />}
              {ROUTES.PORTAL.PATH !== ROUTES.PORTAL.ROUTES.ONBOARDING.PATH && (
                <Route path={ROUTE.PATH} key={ROUTE.PATH}>
                  <ROUTE.COMPONENT />
                </Route>
              )}
            </Fragment>
          ))}
          <Redirect to={ROUTES.PORTAL.ROUTES.NUTRITION.PATH} />
        </>
      )}
      {!user.onboardedAt && (
        <>
          <Route path={ROUTES.PORTAL.ROUTES.ONBOARDING.PATH}>
            <ROUTES.PORTAL.ROUTES.ONBOARDING.COMPONENT />
          </Route>
          <Redirect to={ROUTES.PORTAL.ROUTES.ONBOARDING.PATH} />
        </>
      )}
    </Switch>
  );
};
